import Vue from 'vue';
import multiguard from 'vue-router-multiguard';
import Router from 'vue-router';
import Login from '@/views/Login';
import ForgotPassword from '@/views/ForgotPassword';
import ResetPassword from '@/views/ResetPassword';
// import multiguard from 'vue-router-multiguard'
// import Dashboard from '@/views/Dashboard'
import Layout from '@/views/Layout';
import PreviewLayout from '@/views/PreviewLayout';
import store from '@/store';

Vue.use(Router);

// const ifNotAuthenticated = (to, from, next) => {
//   if (!store.getters.isAuthenticated) {
//     next()
//     return
//   }
//   next('/dashboard')
// }
// this.$router.beforeEach((to, from, next) => {
//   if (!to.matched.length) {
//     next('/notFound')
//   } else {
//     next()
//   }
// })

// TODO create figuard for users type

const ifNotAuthenticated = (to, from, next) => {
  const authUser = store.state.data.tokenData;
  if (authUser && authUser.access_token) {
    next('/dashboard');
    return;
  }
  next();
};

// const ifHasLevelAccess = (to, from, next) => {
//   const levelID = store.state.data.UserData.level_id;

//   if (levelID !== 'undefined' && levelID === '3') {
//     next();
//   } else {
//     next('/');
//   }
// };

// TODO EVERY ROUTE NEEDS PERMISSIONS OTHERWISE USER CAN ACCESS THE ROUTE DIRECTLY BY THE ADDRESS BAR
function ifAuthenticated(to, from, next) {
  const authUser = store.state.data.tokenData;
  // console.log(authUser);
  // console.log(store.getters['data/userRoleGetter']);
  // console.log(store.getters['data/userTypeGetter']);
  // console.log(to.meta.permission);
  if (
    authUser &&
    authUser.access_token &&
    store.state.data.UserData.id &&
    store.state.data.Translations
  ) {
    if (to.meta.permission) {
      if (
        store.getters['data/userRoleGetter'] &&
        to.meta.permission.includes(store.getters['data/userRoleGetter'])
      ) {
        let userType = store.getters['data/userTypeGetter'];
        // console.log(userType);
        // console.log(store.getters['data/userRoleGetter']);
        switch (store.getters['data/userRoleGetter']) {
          case 'greg-user':
            if (
              userType === 2 &&
              store.getters['data/UserDataGetter'].company === 'Gregorys SA'
            ) {
              next();
              break;
            } else {
              next('/');
              break;
            }

          case 'user':
            if (userType === 2) {
              next();
              break;
            } else {
              next('/');
              break;
            }

          case 'trainee':
            if (userType === 2) {
              next();
              break;
            } else {
              next('/');
              break;
            }

          case 'franchisee':
            if (userType === 2 || userType === 23) {
              next();
              break;
            } else {
              next('/');
              break;
            }
          case 'store_manager':
            if (userType === 2 || userType === 23) {
              next();
              break;
            } else {
              next('/');
              break;
            }

          case 'azureUser':
            if (store.getters['data/azureUserGetter']) {
              next();
              break;
            } else {
              next('/');
              break;
            }
        }
      } else {
        next('/');
      }
    } else {
      next();
    }
  } else if (
    authUser &&
    authUser.access_token &&
    !store.state.data.UserData.id
  ) {
    // * we need to account_id  in order to call for company details, so we first are waiting for userRequest Response in order to dispatch getCompanyDetails
    Promise.all([
      store.dispatch('data/getAllStores').then(async () => {
        store
          .dispatch('data/userRequest')
          .then(async () => {
            await store.dispatch('data/getCompanyDetails');
          })
          .catch(() => {
            localStorage.removeItem('authUser');
            localStorage.removeItem('authBUser');
            localStorage.removeItem('weg-portal');
            this.$store.state.data.tokenData = '';
            next('/');
          });
      }),
      store.dispatch('data/BaseLoad').then(() => {
        store.dispatch('data/getMenus');
      }),
      store.dispatch('data/getBanners'),
      store.dispatch('data/getPages')
    ]).then(() => {
      store.commit('data/setAppLoaded', true);
      next();
    });
  } else {
    localStorage.removeItem('authUser');
    localStorage.removeItem('authBUser');
    localStorage.removeItem('weg-portal');
    store.state.data.tokenData = '';
    next('/');
  }
  // store.dispatch('data/getCompanyDetails')
}

//* nobody can access this route

const noAccess = (to, from, next) => {
  next('/');
};

export default new Router({
  // mode: process.env.NODE_ENV === 'development' ? 'history' : 'hash',
  mode: 'history',
  // base: '/portal/',
  base: process.env.NODE_ENV === 'development' ? '' : '/portal/',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/register',
      name: 'Register',
      component: Login,
      props: { modal: 'RegisterForm' },
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/setpassword',
      component: Login,
      name: 'setpassword',
      props: { modal: 'PasswordReset' },
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/resetpassword/:hash',
      component: ResetPassword,
      name: 'resetpassword',
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/resetpassword',
      component: ForgotPassword,
      name: 'forgotpassword',
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/emailverify/:hash',
      component: Login,
      name: 'emailverify',
      props: { modal: 'EmailVerify' },
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/error',
      component: Layout,
      redirect: '/error',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/error',
          component: () => import('@/views/errorPage/404.vue'),
          name: 'error',
          meta: { title: 'error', icon: 'notFound' }
        }
      ]
    },
    { path: '*', redirect: '/error', hidden: true },
    {
      path: '/about us',
      component: Layout,
      redirect: '/about',
      beforeEnter: multiguard([ifAuthenticated]),
      // beforeEnter: multiguard([ifAuthenticated, showRoute]),
      children: [
        {
          path: '/about',
          component: () => import('@/views/About'),
          name: 'about',
          meta: { title: 'about us', icon: 'about' }
        }
      ]
    },
    {
      path: '/api',
      component: Layout,
      redirect: '/api',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/api',
          component: () => import('@/views/Api'),
          name: 'api',
          meta: { title: 'api', icon: 'api' }
        }
      ]
    },
    {
      path: '/allproductsandservices',
      component: Layout,
      redirect: '/allproductsandservices',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/allproductsandservices',
          component: () => import('@/components/Tables/ProductsTable/index.vue')
        }
      ]
    },
    {
      path: '/activity',
      component: Layout,
      redirect: '/activity',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/activity',
          component: () => import('@/views/Activity'),
          name: 'activity',
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'trainee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/allclients',
      component: Layout,
      redirect: '/allclients',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/allclients',
          component: () => import('@/components/Tables/GenericTable/index.vue')
        }
      ]
    },
    {
      path: '/calendar',
      component: Layout,
      redirect: '/calendar',
      beforeEnter: multiguard([noAccess]),
      children: [
        {
          path: '/calendar',
          component: () => import('@/components/Calendar/Calendar')
        }
      ]
    },
    {
      path: '/dashboard',
      component: Layout,
      redirect: '/dashboard',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/dashboard',
          component: () => import('@/views/Dashboard'),
          name: 'dashboard',
          meta: { title: 'dashboard', icon: 'dashboard' }
        }
      ]
    },
    {
      path: '/equipment-maintenance',
      component: Layout,
      redirect: '/equipment-maintenance',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/equipment-maintenance',
          component: () => import('@/views/Equipment-Maintenance'),
          name: 'equipment-maintenance',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/evaluations',
      component: Layout,
      redirect: '/evaluations',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/evaluations',
          component: () => import('@/views/Evaluations'),
          name: 'evaluations',
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/evaluations-report',
      component: Layout,
      redirect: '/evaluations-report',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/evaluations-report',
          component: () => import('@/views/Evaluations-report'),
          name: 'evaluations-report',
          meta: {
            permission: [
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/evaluations-report/:id',
      component: Layout,
      redirect: '/evaluations-report/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/evaluations-report/:id',
          component: () => import('@/views/Evaluations-report'),
          name: 'evaluations-report-specs',
          meta: {
            permission: [
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/checklists',
      component: Layout,
      redirect: '/checklists',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/checklists',
          component: () => import('@/views/CheckLists'),
          name: 'checklists',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/checklists/:id',
      component: Layout,
      redirect: '/checklists/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/checklists/:id',
          component: () => import('@/views/CheckLists'),
          name: 'checklist-specs',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/maintenance',
      component: Layout,
      redirect: '/maintenance',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/maintenance',
          component: () =>
            import('@/views/Equipment-Maintenance/maintenanceView'),
          name: 'maintenance',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/maintenance/:id',
      component: Layout,
      redirect: '/maintenance/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/maintenance/:id',
          component: () =>
            import('@/views/Equipment-Maintenance/maintenanceView'),
          name: 'maintenance_details',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    // {
    //   path: '/receipts',
    //   component: Layout,
    //   redirect: '/receipts',
    //   beforeEnter: multiguard([ifAuthenticated]),
    //   children: [
    //     {
    //       path: '/receipts',
    //       component: () => import('@/views/Receipts'),
    //       name: 'receipts',
    //       meta: { permission: ['franchisee', 'store_manager'] }
    //     }
    //   ]
    // },
    {
      path: '/files',
      component: Layout,
      redirect: '/files',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/files',
          component: () => import('@/views/Files'),
          name: 'files',
          meta: {
            from: 'files',
            title: 'files',
            icon: 'files',
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'trainee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/invoices',
      component: Layout,
      redirect: '/invoices',
      beforeEnter: multiguard([noAccess]),
      children: [
        {
          path: '/invoices',
          component: () => import('@/views/Invoices'),
          name: 'invoices'
        }
      ]
    },
    // {
    //   path: '/knowledgebase',
    //   component: Layout,
    //   redirect: '/knowledgebase',
    //   beforeEnter: multiguard([ifAuthenticated]),
    //   children: [
    //     {
    //       path: '/knowledgebase',
    //       component: () => import('@/views/knowledgeBase'),
    //       name: 'knowledgebase'
    //     }
    //   ]
    // },
    // {
    //   path: '/knowledgebase/:id',
    //   component: Layout,
    //   redirect: '/knowledgebase/:id',
    //   beforeEnter: multiguard([ifAuthenticated]),
    //   children: [
    //     {
    //       path: '/knowledgebase/:id',
    //       component: () => import('@/views/knowledgeBase/kbDetails'),
    //       name: 'KbNoteDetails',
    //       meta: { from: 'knowledgebase' }
    //     }
    //   ]
    // },
    {
      path: '/licenses',
      component: Layout,
      redirect: '/licenses',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/licenses',
          component: () => import('@/views/Licenses'),
          name: 'licenses',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/license',
      component: Layout,
      redirect: '/license',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/license',
          component: () => import('@/views/Licenses/license'),
          name: 'license',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/license/:id',
      component: Layout,
      redirect: '/license/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/license/:id',
          component: () => import('@/views/Licenses/license'),
          name: 'license_details',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/messages',
      component: Layout,
      redirect: '/messages',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/messages',
          component: () => import('@/views/Messages'),
          name: 'messages',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/new_ticket_old',
      component: Layout,
      redirect: '/new_ticket_old',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/new_ticket_old',
          component: () => import('@/components/Tickets/NewTicket'),
          name: 'new_ticket',
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/new_ticket',
      component: Layout,
      redirect: '/new_ticket',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/new_ticket',
          component: () => import('@/components/Tickets_v2/Ticket'),
          name: 'new_ticket_v2',
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/notes',
      component: Layout,
      redirect: '/notes',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/notes',
          component: () => import('@/views/Notes/Notes'),
          name: 'notes'
        }
      ]
    },
    {
      path: '/notes/:id',
      component: Layout,
      redirect: '/notes/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/notes/:id',
          component: () => import('@/views/Notes/noteDetails'),
          name: 'NoteDetails',
          meta: { from: 'notes' }
        }
      ]
    },
    {
      path: '/note-videos',
      component: Layout,
      redirect: '/note-videos',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/note-videos',
          component: () => import('@/views/Notes/NoteVideos'),
          name: 'notes-videos'
        }
      ]
    },
    {
      path: '/orders',
      component: Layout,
      redirect: '/orders',
      beforeEnter: multiguard([noAccess]),
      children: [
        {
          path: '/orders',
          component: () => import('@/views/Orders'),
          name: 'orders'
        }
      ]
    },
    {
      path: '/projects overview',
      component: Layout,
      redirect: '/projects',
      beforeEnter: multiguard([noAccess]),
      children: [
        {
          path: '/projects',
          component: () => import('@/views/ProjectsOverview'),
          name: 'projects overview',
          meta: { title: 'projects overview', icon: 'projects' }
        }
      ]
    },
    {
      path: '/posts',
      component: Layout,
      redirect: '/posts',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/posts',
          component: () => import('@/views/Posts/index.vue'),
          name: 'posts',
          meta: {
            title: 'posts',
            icon: 'settings',
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/posts/:id',
      component: Layout,
      redirect: '/posts/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/posts/:id',
          component: () => import('@/views/Posts/PostDetails'),
          name: 'PostDetails',
          meta: {
            from: 'posts',
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'trainee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/preview',
      component: PreviewLayout,
      redirect: '/preview',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/preview',
          component: () => import('@/components/preview'),
          name: 'preview'
        }
      ]
    },
    {
      path: '/page/:id',
      component: Layout,
      redirect: '/page/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/page/:id',
          component: () => import('@/views/Page'),
          name: 'page'
        }
      ]
    },
    // {
    //   path: '/stock',
    //   component: Layout,
    //   redirect: '/stock',
    //   beforeEnter: multiguard([ifAuthenticated, isFranchisee]),
    //   // beforeEnter: multiguard([noAccess]),
    //   children: [
    //     {
    //       path: '/stock',
    //       component: () => import('@/views/Stock'),
    //       name: 'stock'
    //     }
    //   ]
    // },
    {
      path: '/subscriptions',
      component: Layout,
      redirect: '/subscriptions',
      beforeEnter: multiguard([noAccess]),
      children: [
        {
          path: '/subscriptions',
          component: () => import('@/views/Subscriptions'),
          name: 'subscriptions',
          meta: { title: 'subscriptions', icon: 'subscriptions' }
        }
      ]
    },
    {
      path: '/settings',
      component: Layout,
      redirect: '/settings',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/settings',
          component: () => import('@/views/Settings'),
          name: 'settings',
          meta: {
            title: 'settings',
            icon: 'tasks',
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'trainee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/tasks',
      component: Layout,
      redirect: '/tasks',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/tasks',
          component: () => import('@/views/Tasks'),
          name: 'tasks',
          meta: {
            title: 'tasks',
            icon: 'tasks',
            noCache: true,
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'trainee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/tickets_old',
      component: Layout,
      redirect: '/tickets_old',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/tickets_old',
          component: () => import('@/views/Tickets'),
          name: 'tickets',
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/tickets',
      component: Layout,
      redirect: '/tickets',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/tickets',
          component: () => import('@/views/Tickets_v2'),
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/tickets_old/:id',
      component: Layout,
      redirect: '/tickets_old/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/tickets_old/:id',
          component: () => import('@/views/TicketDetails'),
          name: 'TicketDetails',
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/tickets/:id',
      component: Layout,
      redirect: '/tickets/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/tickets/:id',
          component: () => import('@/views/Tickets_v2/TicketDetails'),
          meta: {
            permission: [
              'azureUser',
              'greg-user',
              'user',
              'franchisee',
              'store_manager'
            ]
          }
        }
      ]
    },
    {
      path: '/training',
      component: Layout,
      redirect: '/training',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/training',
          component: () => import('@/views/Training'),
          name: 'training'
        }
      ]
    },
    {
      path: '/faq',
      component: Layout,
      redirect: '/faq',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/faq',
          component: () => import('@/views/FAQ/index.vue'),
          name: 'faq'
        }
      ]
    },
    {
      path: '/faq/:id',
      component: Layout,
      redirect: '/faq/:id',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/faq/:id',
          component: () => import('@/views/FAQ/PostDetails'),
          name: 'FaqDetails',
          meta: {
            from: 'faq'
          }
        }
      ]
    },
    {
      path: '/training-history',
      component: Layout,
      redirect: '/training-history',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/training-history',
          component: () => import('@/views/Training/trainingArchive'),
          name: 'training-history',
          meta: {
            permission: ['azureUser', 'greg-user', 'user', 'trainee']
          }
        }
      ]
    },
    {
      path: '/training_material',
      component: Layout,
      redirect: '/training_material',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/training_material',
          component: () => import('@/views/Training/trainingMaterial'),
          name: 'training_material'
        }
      ]
    },
    {
      path: '/training-files',
      component: Layout,
      redirect: '/training-files',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/training-files',
          component: () => import('@/views/Training/TrainingFiles'),
          name: 'training-files',
          meta: { permission: ['azureUser', 'greg-user', 'user'] }
        }
      ]
    },
    {
      path: '/information_material',
      component: Layout,
      redirect: '/information_material',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/information_material',
          component: () => import('@/views/Material'),
          name: 'information_material'
        }
      ]
    },
    {
      path: '/upcomingmeetings',
      component: Layout,
      redirect: '/upcomingmeetings',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/upcomingmeetings',
          component: () => import('@/components/MeetingsTable/index.vue'),
          name: 'Upcoming Meetings',
          meta: { title: 'Upcoming Meetings', icon: 'api' }
        }
      ]
    },
    {
      path: '/upcoming',
      component: Layout,
      redirect: '/upcoming',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/upcoming',
          component: () => import('@/components/MeetingsTable/index.vue')
        }
      ]
    },
    {
      path: '/users',
      component: Layout,
      redirect: '/users',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/users',
          component: () => import('@/views/Users/index'),
          name: 'users',
          meta: { permission: ['franchisee', 'store_manager'] }
        }
      ]
    },
    {
      path: '/targit-reports',
      component: Layout,
      redirect: '/targit-reports',
      beforeEnter: multiguard([ifAuthenticated]),
      children: [
        {
          path: '/targit-reports',
          component: () => import('@/views/TargitReports/index'),
          name: 'targit-reports'
        }
      ]
    }
    // {
    //   path: '/page/:id',
    //   component: Layout,
    //   redirect: '/:id',
    //   beforeEnter: multiguard([ifAuthenticated]),
    //   children: [{
    //     path: '/:id',
    //     component: () => import('@/views/Page'),
    //     name: 'page',
    //     meta: { title: 'page', icon: 'page'}
    //   }]
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js